/* ============================================================
   LG EXIT INTENT
   ============================================================
   Catches the visitor who is leaving without buying and offers the 5-a-day
   quiz. It does NOT capture an email itself — the quiz does that, and the quiz
   is the reason to hand one over. A bare "join our newsletter" box is a weak
   ask, and a discount is the wrong one: it collides with the subscription offer
   and trains discount-seeking on the page that converts best.

   WHY NOT A KLAVIYO POPUP. Klaviyo's own form engine loads on every page and
   currently renders nothing — one form has existed in the account's history and
   it went dark at the end of February, cause unresolved. Building the last
   remaining capture surface on top of that is not a bet worth taking, and since
   the ask is "take the quiz" rather than "give us your email", nothing here
   needs Klaviyo at all.

   IT IS DELIBERATELY HARD TO TRIGGER. Everything below is a reason NOT to show
   it. An interruption you have earned is worth many that you have not, and this
   fires at most once per visitor per suppression window.
   ============================================================ */

(function () {
  var root = document.getElementById('LgExitIntent');
  if (!root) return;

  var cfg;
  try {
    cfg = JSON.parse(root.getAttribute('data-config') || '{}');
  } catch (e) {
    return;
  }

  var KEY = 'lg_exit_intent_seen';
  var panel = root.querySelector('.lg-exit__panel');
  var closers = root.querySelectorAll('[data-lg-exit-close]');
  var cta = root.querySelector('.lg-exit__btn');
  var lastFocus = null;
  var shown = false;
  var armed = false;

  /* ---- reasons not to show ---- */

  function suppressed() {
    /* A visitor who has seen it, dismissed it or taken it is done for the
       window. Private-mode browsers throw on localStorage; treat that as
       "cannot remember", which errs toward showing it once rather than never. */
    try {
      var until = window.localStorage.getItem(KEY);
      return until && Date.now() < parseInt(until, 10);
    } catch (e) {
      return false;
    }
  }

  function remember() {
    try {
      window.localStorage.setItem(KEY, String(Date.now() + cfg.days * 86400000));
    } catch (e) {
      /* nothing to do — it simply may show again on the next visit */
    }
  }

  /* Timezone and language are a PROXY for "can actually buy from us", not a
     lookup. The store ships to GB, GG, IM and JE only, so interrupting anyone
     else buys an annoyed visitor and a subscriber who can never order. It fails
     OPEN: if the browser will not tell us, the popup shows. Hiding it from a
     real UK visitor is the worse error of the two. */
  function canBuy() {
    if (!cfg.ukOnly) return true;
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      if (tz === 'Europe/London') return true;
      var lang = (navigator.language || '').toLowerCase();
      if (lang === 'en-gb') return true;
      return !tz && !lang;
    } catch (e) {
      return true;
    }
  }

  if (suppressed() || !canBuy()) return;

  /* ---- showing it ---- */

  function open() {
    if (shown) return;
    shown = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    /* Force a frame so the transition runs from the hidden state. */
    requestAnimationFrame(function () {
      root.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
    /* Focus the dialog itself, not the close button. The panel carries
       aria-labelledby, so landing on it announces the heading — the thing that
       explains why the dialog appeared. Landing on the close button announces
       only "Close". */
    panel.focus();
    remember();
    document.addEventListener('keydown', onKey);
  }

  function close() {
    root.classList.remove('is-open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    var done = function () {
      root.hidden = true;
      root.removeEventListener('transitionend', done);
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) done();
    else root.addEventListener('transitionend', done);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape') {
      close();
      return;
    }
    if (e.key !== 'Tab') return;
    /* Trap focus inside the dialog. */
    var f = panel.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  for (var i = 0; i < closers.length; i++) closers[i].addEventListener('click', close);
  if (cta) cta.addEventListener('click', remember);

  /* ---- arming ---- */

  /* Nothing may fire until the visitor has been here long enough to have read
     something. Without this the popup lands on people who are still waiting for
     the hero image. */
  setTimeout(function () {
    armed = true;
  }, cfg.delay * 1000);

  var touch = window.matchMedia('(hover: none)').matches;

  if (!touch) {
    /* Desktop: the cursor leaving through the TOP of the viewport. Leaving
       sideways is a second monitor, not an exit. */
    document.addEventListener('mouseout', function (e) {
      if (!armed || shown) return;
      if (e.relatedTarget || e.clientY > 0) return;
      open();
    });
  } else {
    /* Touch has no exit to intend, so the trigger is engagement instead:
       someone who has read past halfway and stayed a while. Back-button
       interception was considered and rejected — hijacking Back to show an ad
       is the single most resented pattern on mobile. */
    var deep = false;
    window.addEventListener(
      'scroll',
      function () {
        if (deep || shown) return;
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h > 0 && window.scrollY / h >= cfg.scroll) {
          deep = true;
          if (armed) open();
          else
            setTimeout(function () {
              if (!shown) open();
            }, cfg.delay * 1000);
        }
      },
      { passive: true }
    );
  }
})();
